module.exports = __webpack_public_path__ + "static/media/codequest_winners.8eb285f2.jpeg";